export default function () {
  this.loadNotifications()
}
